export const CURRENCY = "$";
export var recordsLimit = 10;
export var recordsLimit50 = 50;

export const GOOGLE_MAPS_API_KEY = "AIzaSyA_ZFTm165Chs8xXMH4mb2QsOer-RanwQM";

export const LISTING_TYPES = {
  REAL_ESTATE: "real-state",
  CAR: "car",
};

export const VEHICLE_TABS = {
  ARCHIVED: "archived",
  PUBLISHED: "published",
  DRAFT: "draft",
};

export const TRANSACTION_STATUS = {
  SUCCESS: "success",
  FAILED: "failed",
  PENDING: "pending",
};
